// useMediaQuery — живая подписка на matchMedia (первая в проекте: до этого
// адаптивности не было). Драйвер мобильного шелла: AppLayout переключается
// на MobileShell при '(max-width: 768px)'.

import { useEffect, useState } from 'react'

// jsdom не реализует matchMedia — среда без него (тесты) считается десктопом.
function canMatchMedia(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
}

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    canMatchMedia() ? window.matchMedia(query).matches : false
  )

  useEffect(() => {
    if (!canMatchMedia()) return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
